import { useState } from "react";
import { useSelector } from "react-redux";
import EmployeesService from "../../../../../../services/HRM/EmployeesService";
import { Link, useNavigate } from "react-router-dom";
import { Badge } from "react-bootstrap";
import DeleteModal from "../../../../../common/DeleteModal";
import ResetPasswordModal from "../../../../../common/ResetPasswordModal";
import { toast } from "react-toastify";
import { Translate } from "../../../../../Enums/Tranlate";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const [resetPasswordModal, setResetPasswordModal] = useState(false);
	const [type, setType] = useState("");
	const [unlocking, setUnlocking] = useState(false);
	const navigate = useNavigate();
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const employeesService = new EmployeesService();

	const handleUnlockDevice = () => {
		setUnlocking(true);
		employeesService
			.unlockDevice(item.id)
			.then((res) => {
				if (res?.status === 200)
					toast.success(Translate[lang]?.updated_successfully);
			})
			.finally(() => setUnlocking(false));
	};

	return (
		<tr key={index} className="text-center">
			<td>
				<strong className="emp-id">{item.id}</strong>
			</td>
			<td>
				<Link to={`/employee/${item.id}`} state={item} className="profile-link">
					{item?.name}
				</Link>
			</td>
			<td>{item?.personalEmail}</td>

			<td
				style={{
					display: "grid",
					gridTemplateColumns: "auto auto",
					gap: "8px",
				}}>
				{item?.branches?.map((res) => (
					<Badge variant="primary">{res?.names[lang]}</Badge>
				)) || "-"}
			</td>
			<td>{item.department?.name || "-"}</td>
			<td>{item?.companyEmail}</td>
			<td>{item.designation?.title || "- "}</td>
			<td>{item?.startDate?.slice(0, 10) || "-"}</td>

			<td>
				{/* {isExist("edit_employees") && isExist("delete_employees") && ( */}
				<div>
					{/* <i className="la la-road-sign"></i> */}
					{/* <i className="la la-key emp-action"></i> */}
					<i
						className={`la la-unlock emp-action ${unlocking ? " opacity-50" : ""}`}
						style={{ pointerEvents: unlocking ? "none" : "auto" }}
						onClick={handleUnlockDevice}
					/>
					<i
						className="la la-key emp-action"
						title={Translate[lang]?.reset_password}
						onClick={() => setResetPasswordModal(true)}
					/>
					<i
						className="la la-pencil emp-action"
						onClick={() => {
							navigate(`/employee/edit-employee/${item?.id}`);
						}}
					/>
					<i
						className="la la-trash emp-action"
						onClick={() => {
							setDeleteModal(true);
							setType("delete");
						}}
					/>
				</div>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={employeesService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
					type={type}
				/>
			)}
			{resetPasswordModal && (
				<ResetPasswordModal
					open={resetPasswordModal}
					titleMsg={item?.name}
					item={item}
					modelService={employeesService}
					onCloseModal={setResetPasswordModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
